/** Shared class names for the Polymers & Biomolecules Lab components. */
export const CARD_CLASS =
  'min-w-0 rounded-[2rem] border border-hairline bg-canvas-pure p-5 shadow-card-soft lg:p-6';

export function chipClass(active: boolean): string {
  return `rounded-2xl border px-4 py-3 text-left text-sm font-extrabold transition-colors motion-reduce:transition-none ${
    active
      ? 'border-ink bg-ink text-white'
      : 'border-hairline bg-surface text-ink hover:bg-wash-sky'
  }`;
}
